export var ViewMarkup;
(function (ViewMarkup) {
    ViewMarkup["BUTTON"] = "button";
    ViewMarkup["INPUT"] = "input";
    ViewMarkup["A"] = "a";
    ViewMarkup["SPAN"] = "span";
    ViewMarkup["DIV"] = "div";
    ViewMarkup["P"] = "p";
    ViewMarkup["UL"] = "ul";
    ViewMarkup["LI"] = "li";
    ViewMarkup["LABEL"] = "label";
    ViewMarkup["MAIN"] = "main";
    ViewMarkup["SUMMARY"] = "summary";
    ViewMarkup["DETAILS"] = "details";
    ViewMarkup["OL"] = "ol";
    ViewMarkup["DL"] = "dl";
    ViewMarkup["DT"] = "dt";
    ViewMarkup["DD"] = "dd";
    ViewMarkup["DIALOG"] = "dialog";
})(ViewMarkup || (ViewMarkup = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiVmlld1Byb3BzLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vY29tcG9uZW50cy92aWV3L1ZpZXdQcm9wcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFhQSxNQUFNLENBQU4sSUFBWSxVQWtCWDtBQWxCRCxXQUFZLFVBQVU7SUFDcEIsK0JBQWlCLENBQUE7SUFDakIsNkJBQWUsQ0FBQTtJQUNmLHFCQUFPLENBQUE7SUFDUCwyQkFBYSxDQUFBO0lBQ2IseUJBQVcsQ0FBQTtJQUNYLHFCQUFPLENBQUE7SUFDUCx1QkFBUyxDQUFBO0lBQ1QsdUJBQVMsQ0FBQTtJQUNULDZCQUFlLENBQUE7SUFDZiwyQkFBYSxDQUFBO0lBQ2IsaUNBQW1CLENBQUE7SUFDbkIsaUNBQW1CLENBQUE7SUFDbkIsdUJBQVMsQ0FBQTtJQUNULHVCQUFTLENBQUE7SUFDVCx1QkFBUyxDQUFBO0lBQ1QsdUJBQVMsQ0FBQTtJQUNULCtCQUFpQixDQUFBO0FBQ25CLENBQUMsRUFsQlcsVUFBVSxLQUFWLFVBQVUsUUFrQnJCIn0=